import React, { memo } from 'react'
import { Input, Select } from 'antd'
import { Icon } from '@iconify/react'

import DateRangePicker from '../../../projects/components/DateRangePicker'
import { REPORTING_DATE_DISPLAY_FORMAT } from '../../reporting.constants'
import ProjectMultiSelect from '../../../../components/ProjectMultiSelect'
import { CAPACITY_STATUS_OPTIONS } from '../capacity.constants'
import styles from '../ProjectCapacityDashboard.module.css'

const CapacityFilters = memo(
    ({
        search,
        projectIds,
        projects,
        statusFilter,
        start,
        end,
        onSearchChange,
        onProjectChange,
        onProjectSearch,
        onProjectPopupScroll,
        projectListLoading,
        projectListPage,
        onProjectOpenChange,
        onStatusChange,
        onDateRangeChange,
        onReset,
        onExport,
    }) => (
        <div className={styles.toolbar}>
            <div className={styles.controls}>
                <div className={styles.filterField}>
                    <span className={styles.filterLabel}>Search</span>
                    <div className={styles.searchWrap}>
                        <Input
                            allowClear
                            placeholder="Search by name"
                            className={styles.search}
                            value={search}
                            onChange={(e) => onSearchChange(e.target.value)}
                            prefix={
                                <Icon
                                    icon="mdi:magnify"
                                    width={18}
                                    height={18}
                                />
                            }
                        />
                    </div>
                </div>

                <div className={styles.filterField}>
                    <span className={styles.filterLabel}>Date range</span>
                    <div className={styles.dateFilterWrap}>
                        <DateRangePicker
                            value={{ start, end }}
                            onChange={onDateRangeChange}
                            placeholder="Date range"
                            parentComponent="taskDetailView"
                            dateFormat={REPORTING_DATE_DISPLAY_FORMAT}
                        />
                    </div>
                </div>

                <div className={styles.filterField}>
                    <span className={styles.filterLabel}>Projects</span>
                    <ProjectMultiSelect
                        projects={projects}
                        value={projectIds}
                        onChange={onProjectChange}
                        placeholder="Select Projects"
                        showSearch
                        filterOption={false}
                        onSearch={onProjectSearch}
                        onPopupScroll={onProjectPopupScroll}
                        loading={projectListLoading}
                        page={projectListPage}
                        onOpenChange={onProjectOpenChange}
                    />
                </div>

                <div className={styles.filterField}>
                    <span className={styles.filterLabel}>Status</span>
                    <Select
                        className={styles.filterSelectSingle}
                        value={statusFilter}
                        options={CAPACITY_STATUS_OPTIONS}
                        onChange={onStatusChange}
                        suffixIcon={
                            <Icon
                                icon="mdi:chevron-down"
                                width={18}
                                height={18}
                                className={styles.filterChevron}
                            />
                        }
                    />
                </div>

                <div className={styles.filterActions}>
                    <button
                        type="button"
                        className={styles.pillBtn}
                        onClick={onReset}
                    >
                        Reset
                    </button>
                    <button
                        type="button"
                        className={styles.exportBtn}
                        onClick={onExport}
                        disabled
                        title="Export coming soon"
                    >
                        <Icon
                            icon="mdi:export-variant"
                            width={16}
                            height={16}
                        />
                        Export
                    </button>
                </div>
            </div>
        </div>
    )
)

CapacityFilters.displayName = 'CapacityFilters'

export default CapacityFilters
